import * as React from 'react';
import { Link, useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Wrapper from '@components/Wrapper';
import Label from '@components/Label';
import IconLink from '@components/IconLink';
import germanyBlog from '@icons/flags/germanyBlog';
import usaBlog from '@icons/flags/usaBlog';
import PostAuthorHead from '../PostAuthor/postAuthorHead';
import PostFooter from '../PostFooter';
import * as styles from './style.module.scss';

const {
  postHero,
  postHero__content,
  postHero__text,
  postHero__title,
  postHero__category,
  postHero__other,
  postHero__image,
  postHero__link,
  postHero__author,
  postHero__back,
} = styles;

const Hero = ({
  category,
  title,
  author,
  date,
  otherVersion,
  image,
  metaTitle,
  metaDescription,
}) => {
  const img = getImage(image);
  const { t } = useTranslation();
  const { language } = useI18next();
  return (
    <section className={postHero}>
      <Wrapper>
        <Label classes={postHero__category}>
          <IconLink
            classes={postHero__back}
            theme="reverse"
            withTail
            href="/blog/"
          >
            {t('play_breadcrumb_all')}
          </IconLink>
          <span className="blue-accent">{category.name}</span>
        </Label>
        <div className={postHero__content}>
          <div className={postHero__text}>
            <h1 className={postHero__title}>{title}</h1>
            <div className={postHero__author}>
              <PostAuthorHead author={author} theme="simple" />
              {date && <span>{date}</span>}
              <PostFooter
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                size="small"
              />
            </div>
            {otherVersion && (
              <p className={postHero__other}>
                {language === 'de' ? usaBlog : germanyBlog}{' '}
                {t('blog_post_page_article')}{' '}
                <Link
                  language={language === 'en' ? 'de' : 'en'}
                  to={`/blog/${otherVersion[0].permalink}`}
                  className={postHero__link}
                >
                  {t('blog_post_page_article_available')}
                </Link>
              </p>
            )}
          </div>
          <GatsbyImage
            className={postHero__image}
            quality={100}
            image={img}
            alt={image.description}
          />
        </div>
      </Wrapper>
    </section>
  );
};

export default Hero
